import { sendMessageToExtension } from '../app/extension-ui/shared/extensionMessage';

export default async function extensionFetchProxy(
  _input: RequestInfo | URL,
  options: RequestInit = {},
) {
  const data = await sendMessageToExtension('fetch', {
    ...options,
    signal: null,
  });

  const getResponse = (): Response => ({
    ok: Math.floor(data.status / 100) === 2,
    statusText: data.statusText,
    status: data.status,
    url: data.url,
    text: () => Promise.resolve(data.responseText),
    json: () => Promise.resolve(data.responseText).then(JSON.parse),
    blob: () => Promise.reject(new Error('Not implemented')),
    arrayBuffer: () => Promise.reject(new Error('Not implemented')),
    formData: () => Promise.reject(new Error('Not implemented')),
    bytes: () => Promise.reject(new Error('Not implemented')),
    clone: getResponse,
    body: null,
    redirected: false,
    bodyUsed: false,
    type: 'cors',
    headers: new Headers(),
  });

  return getResponse();
}
